import React from 'react';
import { Box, Typography } from '@mui/material';
import { formatScalar } from '../utils';

export const DetailField = ({ label, value, isStatus }) => {
  let displayValue = formatScalar(value);
  
  if (isStatus) {
    if (value === 'true' || value === true) {
      displayValue = <span style={{ color: '#2e7d32', fontWeight: 600 }}>Yes</span>;
    } else if (value === 'false' || value === false) {
      displayValue = <span style={{ color: '#d32f2f', fontWeight: 600 }}>No</span>;
    }
  }

  return (
    <Box className="wivi-detail-field">
      <Typography variant="body2" className="wivi-detail-label">
        {label}
      </Typography>
      <Typography variant="body2" className="wivi-detail-value">
        {displayValue}
      </Typography>
    </Box>
  );
};
